<template>
  <div class="page">
    <Navigation />
    <div class="app-wrapper">
      <div class="app-content pt-3 p-md-3 p-lg-4">
        <div class="container-fluid">
          <div class="row gy-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <h1 class="main-title mt-2 mb-4">Add New Fleet User</h1>
              <div class="panel-box p-5">
                <div class="row">
                  <div class="form-step-col">
                    <form
                      ref="CreateCompanyUserForm"
                      @submit.prevent="CreateCompanyUser"
                    >
                      <div class="row">
                        <div class="col-sm-12 col-lg-4 d-none">
                          <div class="mb-4">
                            <label class="form-label"
                              >User Type<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <select
                              v-model="NewCompanyFleetUser.company_role"
                              class="form-select"
                            >
                              <option value="1">Admin</option>
                              <option value="2">Sales Person</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-12 col-lg-4 company-search">
                          <div class="mb-4">
                            <label class="form-label">Search Company</label>
                            <Select2
                              class="custom_search"
                              v-model="NewCompanyFleetUser.company_id"
                              :options="Companies"
                              placeholder="Select Company"
                              @select="selectResult($event)"
                              label="text"
                              track-by="id"
                              :multiple="false"
                              :taggable="false"
                            />
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-3">
                            <label class="form-label"
                              >Account Role<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <select
                              class="form-control"
                              type="text"
                              v-model="NewCompanyFleetUser.role_id"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.NewCompanyFleetUser.role_id.$error,
                              }"
                            >
                              <option value="" selected>Select Role</option>
                              <option
                                v-for="(Role, RoleIndex) in Roles"
                                :key="RoleIndex"
                                :value="Role.id"
                              >
                                {{ Role.title }}
                              </option>
                            </select>
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.role_id.required
                              "
                              class="invalid-feedback"
                            >
                              Account role is required
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-4">
                            <label class="form-label"
                              >First Name<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter First Name"
                              v-model="NewCompanyFleetUser.forename"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.NewCompanyFleetUser.forename.$error,
                              }"
                            />
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.forename.required
                              "
                              class="invalid-feedback"
                            >
                              First Name is required
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-4">
                            <label class="form-label"
                              >Last Name<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Last Name"
                              v-model="NewCompanyFleetUser.surname"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.NewCompanyFleetUser.surname.$error,
                              }"
                            />
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.surname.required
                              "
                              class="invalid-feedback"
                            >
                              Last Name is required
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-4">
                            <label class="form-label"
                              >Email Address<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Email Address"
                              v-model="NewCompanyFleetUser.email"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.NewCompanyFleetUser.email.$error,
                              }"
                            />
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.email.required
                              "
                              class="invalid-feedback"
                            >
                              Email Address is required
                            </div>
                            <div
                              v-if="
                                submitted && !$v.NewCompanyFleetUser.email.email
                              "
                              class="invalid-feedback"
                            >
                              Valid Email Address is required
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-4">
                            <label class="form-label"
                              >Password<span class="text-danger">*</span></label
                            >
                            <input
                              type="password"
                              class="form-control"
                              placeholder="Enter Password"
                              v-model="NewCompanyFleetUser.password"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.NewCompanyFleetUser.password.$error,
                              }"
                            />
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.password.required
                              "
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                            <div v-if="submitted && !$v.NewCompanyFleetUser.password.minLength" class="d-block invalid-feedback">Password must be at least 8 characters long.</div>
                            <div v-if="submitted && !$v.NewCompanyFleetUser.password.strong" class="d-block invalid-feedback">Password must be strong (eg. include at least 1 capital letter, 1 number and 1 special character)</div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-4">
                            <label class="form-label"
                              >Contact Number<span class="text-danger"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Contact Number"
                              v-model="NewCompanyFleetUser.phone"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.NewCompanyFleetUser.phone.$error,
                              }"
                            />
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.phone.required
                              "
                              class="invalid-feedback"
                            >
                              Contact Number is required
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-3">
                            <label>Branches</label>
                            <select
                              class="form-control"
                              type="text"
                              v-model="NewCompanyFleetUser.branch_ids"
                              multiple
                              style="height: 100px"
                            >
                              <option
                                v-for="(Branch, BranchIndex) in Branches"
                                :key="BranchIndex"
                                :value="Branch.id"
                              >
                                {{ Branch.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                        <div class="form-group">
                          <label>Two Factor Authentication</label>
                          <div class="row tracker-btn">
                            <div class="col">
                              <label
                              class="form-check form-check-single form-switch form-switchs"
                            >
                              <span class="off-button">OFF </span><input
                                class="form-check-input m-0"
                                type="checkbox"
                                v-model="NewCompanyFleetUser.is_2fa_enabled"
                                @change="
                                  $emit('input', $event.target.checked)
                                "
                              /><span class="on-button">ON </span>
                            </label>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="col-sm-12 col-lg-4">
                          <div class="mb-4">
                            <label class="form-label">Profile Image</label>
                            <input
                              class="input form-control"
                              type="file"
                              name="profile_image"
                              ref="ProfileImageFile"
                              :class="{
                                'is-invalid':
                                  $v.NewCompanyFleetUser.profile_image.$error,
                              }"
                              @change="imageFileChanged($event)"
                              accept="image/*"
                            />
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.profile_image
                                  .file_size_validation
                              "
                              class="invalid-feedback"
                            >
                              Please upload less than 1 MB file size image
                            </div>
                            <div
                              v-if="
                                submitted &&
                                !$v.NewCompanyFleetUser.profile_image
                                  .image_type_validation
                              "
                              class="invalid-feedback"
                            >
                              Please upload jpeg, png, gif or svg file only
                            </div>
                            <img
                              v-show="NewCompanyFleetUser.profile_image"
                              ref="ProfileImagePreview"
                              class="icon__preview"
                              width="100"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <router-link
                          :to="{ name: 'Companies' }"
                          class="btn btn-default"
                        >
                          &larr; Back</router-link
                        >
                        <button
                          class="btn btn-primary"
                          v-on:click="CreateCompanyUser()"
                          :disabled="Saving"
                        >
                          Save
                        </button>
                        <Loading v-if="Saving" />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { required, email, minLength } from "vuelidate/lib/validators";
  import Navigation from "@/components/Navigation";
  import Endpoints from "@/Admin/Endpoints";
  import Loading from "@/components/Loading";
  import Swal from "sweetalert2";
  import Axios from "axios";
  import Select2 from "v-select2-component";

  const file_size_validation = (value, vm) => {
    if (!value) {
      return true;
    }
    let file = value;
    return file.size < 1048576;
  };
  const image_type_validation = (value, vm) => {
    if (!value) {
      return true;
    }
    let file = value;
    if (
      file.type == "image/svg+xml" ||
      file.type == "image/jpeg" ||
      file.type == "image/gif" ||
      file.type == "image/png"
    ) {
      return true;
    } else {
      return false;
    }
  };

  export default {
    //props: ["CompanyId"],
    components: {
      Navigation,
      Loading,
      Select2,
    },
    mounted() {
      if (typeof this.$route.params.CompanyId != "undefined") {
        var CompanyId = this.$route.params.CompanyId;
        this.NewCompanyFleetUser.company_id = CompanyId;
        this.CompanyId = CompanyId;
        this.Roles = [];
        this.Branches = [];
        this.GetRoles();
        this.GetBranches();
      }
      this.GetCompanies();
    },
    data() {
      return {
        search: "",
        company: "",
        toggle: false,
        Saving: false,
        submitted: false,
        NewCompanyFleetUser: {
          role_id: "",
          forename: "",
          surname: "",
          email: "",
          password: "",
          company_id: 0,
          phone: "",
          profile_image: "",
          company_role: "1",
          branch_ids: [],
          is_2fa_enabled: false,
        },
        Companies: [],
        SearchCompanies: [],
        CompanyId: 0,
        Roles: [],
        Branches: [],
      };
    },
    validations: {
      NewCompanyFleetUser: {
        role_id: { required },
        forename: { required },
        surname: { required },
        email: { required, email },
        password: { required, minLength: minLength(8),
          strong: (value) => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])/.test(value)
        },
        phone: { required },
        profile_image: { file_size_validation, image_type_validation },
      },
    },
    methods: {
      Set2FA(type){
        this.NewCompanyFleetUser.is_2fa_enabled = type;
      },
      GetBranches() {
        var obj = {
          token: localStorage.getItem("token"),
          company_id: this.CompanyId,
        };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Branches = Response.data.records;
          }
        });
      },
      GetRoles() {
        var obj = {
          token: localStorage.getItem("token"),
          company_id: this.CompanyId,
        };
        Axios.post(Endpoints.Roles.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Roles = Response.data.records;
          }
        });
      },
      GetCompanies() {
        Axios.post(Endpoints.Company.List, {
          token: localStorage.getItem("token"),
          start: 0,
          limit: 100,
        }).then((Response) => {
          let Companies = Response.data.records;
          Companies.forEach((element) => {
            this.Companies.push({ id: element.id, text: element.name });
          });
        });
      },
      imageFileChanged(event) {
        var files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.NewCompanyFleetUser.profile_image = files[0];
        var output = document.querySelector(".icon__preview");
        output.src = URL.createObjectURL(files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
      },
      selectResult(company) {
        this.CompanyName = company.text;
        this.CompanyId = company.id;
        this.NewCompanyFleetUser.company_id = company.id;
        this.Roles = [];
        this.Branches = [];
        if (company.id > 0) {
          this.GetRoles();
          this.GetBranches();
        }
      },
      CreateCompanyUser() {
        this.submitted = true;
        this.$v.$touch();
        //this.NewCompanyFleetUser.company_id = this.CompanyId;
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.Company.FleetUser.Create, {
          token: localStorage.getItem("token"),
          ...this.NewCompanyFleetUser,
        }).then((Response) => {
          if (Response.data.success) {
            this.SaveProfileImage(Response.data.last_id);
          } else {
            Swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      SaveProfileImage(id) {
        var LogoFormData = new FormData();
        if (this.$refs.ProfileImageFile.files[0]) {
          LogoFormData.append("storage_type", "CFU");
          LogoFormData.append("token", localStorage.getItem("token"));
          LogoFormData.append("file", this.$refs.ProfileImageFile.files[0]);
          LogoFormData.append("company_id", this.CompanyId);
          LogoFormData.append("user_id", id);
          Axios.post(Endpoints.Helper.File.Upload, LogoFormData).then(
            (UploadResponse) => {
              var UploadData = UploadResponse.data;
              if (UploadData.success === true) {
                Axios.post(Endpoints.Company.FleetUser.ProfileImageSet, {
                  token: localStorage.getItem("token"),
                  profile_image: UploadData.file,
                  id: id,
                }).then((SetResponse) => {
                  Swal.fire(
                    "Fleet User Added Successfully",
                    "",
                    "success"
                  ).then(() => {
                    this.$refs.CreateCompanyUserForm.reset();
                    this.$emit("recordAdded");
                    this.Saving = false;
                    this.$router.push("/company/fleet/users/" + this.CompanyId);
                  });
                });
              }
            }
          );
        } else {
          Swal.fire("Fleet User Added Successfully", "", "success").then(() => {
            this.$refs.CreateCompanyUserForm.reset();
            this.$emit("recordAdded");
            this.Saving = false;
            this.$router.push("/company/fleet/users/" + this.CompanyId);
          });
        }
      },
      clearCompanyUserModal() {
        this.$refs.CreateCompanyUserForm.reset();
        var self = this;
        Object.keys(this.CreateCompanyUser).forEach(function (subsKey, index) {
          self.CreateCompanyUser[subsKey] = "";
        });
        this.submitted = false;
      },
    },
  };
</script>
<style>
  .form-switch {
    padding-left: 0;
  }
  .modal-backdrop {
    background-color: #232e3c !important;
  }
</style>
